import { request } from "./http";

export interface RobotRow {
  id: string;
  name: string;
  strategy: string;
  status: "loaded" | "running" | "paused" | "stopped" | "error" | string;
  mode: string;
  instruments: string[];
  started_at: string | null;
  last_error: string | null;
  last_error_at: string | null;
  trades: number;
  signals: number;
}

export interface RobotJournalEntry {
  id: number;
  ts: string;
  type: string;
  instrument: string;
  side: string;
  [k: string]: unknown;
}

export interface RobotCreate {
  name: string;
  strategy_type: string;
  mode?: string;
  config_payload?: Record<string, unknown>;
}

export const robots = {
  list: () => request<{ robots: RobotRow[] }>("/piggy/api/robots"),
  status: (id: string) => request<RobotRow>(`/piggy/api/robots/${id}`),
  create: (body: RobotCreate) => request<RobotRow>("/piggy/api/robots", { body }),
  delete: (id: string) =>
    request<{ id: string; deleted: boolean }>(`/piggy/api/robots/${id}`, { method: "DELETE" }),
  start: (id: string) =>
    request<{ status: string; robot_id: string }>(`/piggy/api/robots/${id}/start`, { method: "POST" }),
  stop: (id: string) =>
    request<{ status: string; robot_id: string }>(`/piggy/api/robots/${id}/stop`, { method: "POST" }),
  pause: (id: string) =>
    request<{ status: string; robot_id: string }>(`/piggy/api/robots/${id}/pause`, { method: "POST" }),
  resume: (id: string) =>
    request<{ status: string; robot_id: string }>(`/piggy/api/robots/${id}/resume`, { method: "POST" }),
  trades: (id: string, limit = 100) =>
    request<{ trades: RobotJournalEntry[] }>(`/piggy/api/robots/${id}/trades?limit=${limit}`),
  signals: (id: string, limit = 100) =>
    request<{ signals: RobotJournalEntry[] }>(`/piggy/api/robots/${id}/signals?limit=${limit}`),
  errors: (id: string, limit = 50) =>
    request<{ errors: RobotJournalEntry[] }>(`/piggy/api/robots/${id}/errors?limit=${limit}`),
};
